import { divide } from "lodash";
import React, { Component } from "react";
import { Container, Icon, Divider, Tab, Header, Table, List, Popup, Button, Message, Modal, Form } from 'semantic-ui-react'
import  { invokeApig, downloadS3Text } from "../libs/awsLib";
import { Link} from "react-router-dom";
import { formatAddress, formatDate, formatDateTime, objectOrArraytoArray } from "../libs/sharedFunctions";
import TariffSwitchingTimes from "./TariffSwitchingTimes";
import SmartEvents from "./SmartEvents";
import SmartDeviceOrchestrations from "./SmartDeviceOrchestrations";
import SmartDeviceLog from "./SmartDeviceLog";
import SmartHealthchecks from "./SmartHealthchecks";
import { EUIs } from "../metadata/EUIs";
import config from "../config";
import _ from 'lodash';

export default class SmartDevice extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      deviceConfigurations: {}, 
      alertConfigurations: {}, 
      smartDevice: {}, 
      deviceLoaded: false, 
      site: {}, 
      siteLoaded: false, 
      events: [], 
      manufacturers: {}, 
      esmeVariants: {}, 
      deviceTypes: {}, 
      showSwitchingTimes: false, 
      events: [], 
      hanDevices: [], 
      updateSuccess: false, 
      updateFailed: false, 
      updateMessage: '',
      showUpdateDeviceConfig: false, 
      showUpdateAlertConfig: false
      };
  

  
 }


componentWillReceiveProps(nextProps) {
  const smartdeviceid=nextProps.match.params.smartdeviceid;
  if (smartdeviceid!==this.props.match.params.smartdeviceid)
  this.loadSmartDevice(smartdeviceid)
}

componentDidMount()
{
  const smartdeviceid=this.props.match.params.smartdeviceid;
  this.loadSmartDevice(smartdeviceid);
  // this.loadManufacturers();
  this.loadESMEVariants();
  this.loadDeviceTypes();
  this.loadServiceRequests();
  this.loadDeviceConfigurations();
  this.loadAlertConfigurations();
}

loadSite=(siteid)=>
{

  invokeApig({path: "/api/sites/"+siteid, method: "GET"}).then((result)=>
  {
    this.setState({site: result.data, siteLoaded: true})
    
  });
}

loadManufacturers=()=>
{
  invokeApig({path: '/lookups/smartdevicemanufacturer', method: "GET",  body: null}).then((results)=>
  {
    var manufacturers={};
    results.data.forEach(manufacturer=>{manufacturers[manufacturer.key]=manufacturer.text});

      this.setState({manufacturers: manufacturers});
  })
}

loadESMEVariants=()=>
{
  invokeApig({path: '/lookups/smartesmevariant', method: "GET",  body: null}).then((results)=>
  {
    var esmeVariants={};
    results.data.forEach(esmeVariant=>{esmeVariants[esmeVariant.key]=esmeVariant.text});

      this.setState({esmeVariants: esmeVariants});
  })
}

loadDeviceTypes=()=>
{
  invokeApig({path: '/lookups/smartdevicetype', method: "GET",  body: null}).then((results)=>
  {
    var deviceTypes={};
    results.data.forEach(deviceType=>{deviceTypes[deviceType.key]=deviceType.text});

      this.setState({deviceTypes: deviceTypes});
  })
}

loadSmartDevice=(smartdeviceid)=>
{

  invokeApig({path: "/api/smartdevices/"+smartdeviceid, method: "GET"}).then((result)=>
  {
    this.setState({smartDevice: result.data, deviceLoaded: true})
    this.loadSite(result.data.siteid);
    if (result.data.chfdeviceid)
      this.loadHANDevices(result.data.chfdeviceid);
    
  });
}


loadServiceRequests()
{
  invokeApig({path: '/smart/servicerequests' , method: "GET"}).then((result)=>{
    this.setState({servicerequests: result.data})
  });
}


loadHANDevices=(chfDeviceID)=>
{

  var queryParams=['chfdeviceid='+chfDeviceID]

  invokeApig({path: "/api/smartdevices", method: "GET", queryParams: queryParams}).then((result)=>
  {
    var hanDevices=[];
    var chfDevice=result.data.find(device=>{return device.devicetype==="CHF"})
    if (chfDevice)
    {
      chfDevice.connectedDevices=[]
      if (chfDevice.deviceconfiguration && chfDevice.deviceconfiguration.devicelog && chfDevice.deviceconfiguration.devicelog.CHFDeviceLog && chfDevice.deviceconfiguration.devicelog.CHFDeviceLog.CHFDeviceLogEntry)
      {
        objectOrArraytoArray(chfDevice.deviceconfiguration.devicelog.CHFDeviceLog.CHFDeviceLogEntry).forEach(logEntry=>{
          var subDevice=result.data.find(device=>{return device.deviceid===logEntry.DeviceID})
          if (subDevice)
          {
            //log devices as on han
            chfDevice.han=true;
            subDevice.han=true;
            //load any sub devices
            subDevice.connectedDevices=[]
            if (subDevice.deviceconfiguration && subDevice.deviceconfiguration.devicelog && subDevice.deviceconfiguration.devicelog.DeviceLogEntries && subDevice.deviceconfiguration.devicelog.DeviceLogEntries.LogEntry)
            objectOrArraytoArray(subDevice.deviceconfiguration.devicelog.DeviceLogEntries.LogEntry).forEach(logEntry=>{
              console.log(logEntry)
              var subsubDevice=result.data.find(device=>{return device.deviceid===logEntry.DeviceID})
              if (subsubDevice)
              {
                subDevice.connectedDevices.push(subsubDevice)
                //log device as on han
                subsubDevice.han=true;
                subsubDevice.connectedDevices=[];
              }
            })
            //add device to chf
            chfDevice.connectedDevices.push(subDevice)

          }
        })

      }
      // add to han devices
      hanDevices.push(chfDevice)
    }

    //add non han devices
    result.data.filter(device=>{return !device.han}).forEach(device=>{hanDevices.push(device)})


    this.setState({hanDevices: hanDevices})
  });
}


formatBiillingCalendar=(billingCalendar)=>{
  var calendar;
  const months=['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  if ('ElectricityBillingCalendar' in billingCalendar)
    calendar=billingCalendar.ElectricityBillingCalendar
  else if ('GasBillingCalendar' in billingCalendar)
    calendar=billingCalendar.GasBillingCalendar
  else
  return 'None'

  if ('Monthly' in calendar)
  return 'Day '+calendar.Monthly+ ' of month at '+calendar.BillingTime.slice(0,8)+ ' (UTC)'
  else if ('Daily' in calendar)
  return 'Daily at '+calendar.BillingTime.slice(0,8)+ ' (UTC)'
  else if ('Weekly' in calendar)
  {
    const days = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return days[calendar.Weekly] + ' at '+calendar.BillingTime.slice(0,8)+ ' (UTC)'
  }
  else if ('Quarterly' in calendar)
  {
    return 'Quarterly starting '+ calendar.DayOfMonth + ' ' + months[calendar.BillingPeriodStartMonth] + ' at '+calendar.BillingTime.slice(0,8)+ ' (UTC)'
  }
  else if ('SixMonthly' in calendar)
  {
    return 'Six-monthly starting '+ calendar.DayOfMonth + ' ' + months[calendar.BillingPeriodStartMonth] + ' at '+calendar.BillingTime.slice(0,8)+ ' (UTC)'
  }
  else if ('Yearly' in calendar)
  {
    return 'Yearly on '+ calendar.DayOfMonth + ' ' + months[calendar.BillingPeriodStartMonth] + ' at '+calendar.BillingTime.slice(0,8)+ ' (UTC)'
  }
  else 
    return 'Unknown'

  
  }

  krpCertificateSlot(party, usage)
  {
    if (this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.krpcertificates && this.state.smartDevice.deviceconfiguration.krpcertificates.RemotePartyDetails)

    {
      const findSlot=this.objectToList(this.state.smartDevice.deviceconfiguration.krpcertificates.RemotePartyDetails).find(slot=>{return slot.RemotePartyRole===party && slot.CertificateUsage===usage})
      if (findSlot)
      {
        const euiPrefix=findSlot.ExistingRemotePartyID.substring(0, 17);
        if (euiPrefix in EUIs)
          return findSlot.ExistingRemotePartyID + " (" + EUIs[euiPrefix].name + ")";
        else
          return findSlot.ExistingRemotePartyID;
      }
      
    }
  }

  deviceIcon(deviceType)
  {
    if (deviceType==="CHF")
    return "home"
    else if (deviceType==='ESME')
    return "plug"
    else if (deviceType==='GSME' || deviceType==='GPF')
    return "fire"
    else if (deviceType==='PPMID')
    return "pound"
    else if (deviceType==='IHD')
    return "mobile"

  }
  renderHANDevice(device)
  {
    
    return <List.Item>
    <List.Icon name={this.deviceIcon(device.devicetype) } />
      <List.Content>
        <List.Header>{device.devicetype in this.state.deviceTypes ? this.state.deviceTypes[device.devicetype] : device.devicetype}</List.Header>
        <List.Description><Link to={'../smartdevice/'+device.id}>{device.deviceid}</Link></List.Description>
        {device.connectedDevices && <List.List>
        {device.connectedDevices.map(subDevice=>{return this.renderHANDevice(subDevice)})}
        </List.List>}
      </List.Content>
    </List.Item>
   
  
  }

  healthCheckIcon=(connectivity)=>{
    if (connectivity==1)
    return 'check'
    else if (connectivity==2)
    return 'warning sign'
    else if (connectivity==3)
    return 'x'
  }
  
  healthCheckColour=(status)=>{
    if (status==1)
    return 'green'
    else if (status==2)
    return 'yellow'
    else if (status==3)
    return 'red'
  }
  
  
  

  formatSchedule=(schedule)=>{

        return schedule.ScheduleFrequency + ' at ' + schedule.ScheduleExecutionStartTime.slice(0, 5) + ' from ' + formatDate(new Date(schedule.ScheduleStartDate.slice(0, 10)))
 
  }

  srvDescription(srv)
  {
    const serviceRequest=this.state.servicerequests.find(sr=>{return sr.servicereferencevariant===srv})
    if (serviceRequest)
    return serviceRequest.description
  }

  loadAlertConfigurations=()=>{
      const bucket=config.awsEnv+'.sgserve.config';
      const key=config.stage+'/alertconfigurations.json'
      downloadS3Text(bucket, key).then(result=>{this.setState({alertConfigurations: result})})
  }

  loadDeviceConfigurations=()=>{
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/deviceconfigurationrules.json'
    downloadS3Text(bucket, key).then(result=>{this.setState({deviceConfigurations: result})})
  }

  updateSmartDevice=(key, value)=>{
    var copyDevice=_.cloneDeep(this.state.smartDevice);
    copyDevice[key]=value;
    this.setState({smartDevice: copyDevice});    
  }

  objectToList=(object)=>{
    
    if (Array.isArray(object))
    return object
  else 
    return [object]
  }

  saveSmartDevice=()=>{

    invokeApig({path: "/api/smartdevices/"+this.state.smartDevice.id, method: "PUT", body: this.state.smartDevice}).then((result)=>{
      if (result.status===200)
        this.setState({updateSuccess: true, updateFailed: false, showUpdateDeviceConfig: false, showUpdateAlertConfig: false});
      else
        this.setState({updateSuccess: false, updateFailed: true, validationErrors: result.data, showUpdateDeviceConfig: false, showUpdateAlertConfig: false})
      }).catch(err=>{
      this.setState({updateSuccess: false, updateFailed: true, validationErrors: ['Unknown error'], showUpdateDeviceConfig: false, showUpdateAlertConfig: false})
    })
  }


  render() {

  const modalStyle = {
      modal : {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };

  var tariff;
  if (this.state.smartDevice)
    if (this.state.smartDevice.deviceconfiguration)
      if (this.state.smartDevice.deviceconfiguration.primarytariff)
        if (this.state.smartDevice.deviceconfiguration.primarytariff.Electricity)
        tariff=this.state.smartDevice.deviceconfiguration.primarytariff.Electricity
        else if (this.state.smartDevice.deviceconfiguration.primarytariff.Gas)
        tariff=this.state.smartDevice.deviceconfiguration.primarytariff.Gas

        const headerPanes = []

    const detailPanes = []
    if (this.state.deviceLoaded)
    {

      headerPanes.push({ menuItem: {key: 'Device Details', content: 'Device Details', icon: 'disk'}, render: () => 
      <Tab.Pane>
        <div className="deviceheader">
          <Table className="formtable">
          <Table.Row><Table.Cell><b>Device Configuration</b></Table.Cell><Table.Cell><Link to={'../configure/0'}>{this.state.smartDevice.deviceconfigurationrules}</Link></Table.Cell><Table.Cell><Button onClick={()=>{this.setState({showUpdateDeviceConfig: true})}} floated='left' className='seaglassbutton' size='mini'>Change</Button></Table.Cell></Table.Row>
          <Table.Row><Table.Cell><b>Alert Configuration</b></Table.Cell><Table.Cell><Link to={'../configure/1'}>{this.state.smartDevice.alertconfigurationrules}</Link></Table.Cell><Table.Cell><Button onClick={()=>{this.setState({showUpdateAlertConfig: true})}} floated='left' className='seaglassbutton' size='mini'>Change</Button></Table.Cell></Table.Row>
          {this.state.smartDevice.devicetype!=='CHF' && this.state.smartDevice.chfdeviceid && <Table.Row><Table.Cell><b>Comms Hub</b></Table.Cell><Table.Cell><Link to={'../smartdevices?chfdeviceid='+this.state.smartDevice.chfdeviceid}>{this.state.smartDevice.chfdeviceid}</Link></Table.Cell></Table.Row>}
          {this.state.smartDevice.devicetype==='ESME' && this.state.smartDevice.importmpxn && <Table.Row><Table.Cell><b>Import MPAN</b></Table.Cell><Table.Cell>{this.state.smartDevice.importmpxn}</Table.Cell></Table.Row>}
            {this.state.smartDevice.devicetype==='GSME' && this.state.smartDevice.importmpxn && <Table.Row><Table.Cell><b>MPRN</b></Table.Cell><Table.Cell>{this.state.smartDevice.importmpxn}</Table.Cell></Table.Row>}
            {this.state.smartDevice.devicetype==='ESME' && this.state.smartDevice.secondaryimportmpxn && <Table.Row><Table.Cell><b>Secondary Import MPAN</b></Table.Cell><Table.Cell>{this.state.smartDevice.secondaryimportmpxn}</Table.Cell></Table.Row>}
            {this.state.smartDevice.devicetype==='ESME' && this.state.smartDevice.exportmpxn && <Table.Row><Table.Cell><b>Export MPAN</b></Table.Cell><Table.Cell>{this.state.smartDevice.exportmpxn}</Table.Cell></Table.Row>}

            {this.state.siteLoaded && <Table.Row>
              <Table.Cell verticalAlign="top"><b>Address</b></Table.Cell>
              <Table.Cell><List>{formatAddress(this.state.site).map(addressLine=>{return <List.Item>{addressLine}</List.Item>})}</List></Table.Cell>
            </Table.Row>}
            
            <Table.Row><Table.Cell><b>Device Type</b></Table.Cell><Table.Cell>{this.state.smartDevice.devicetype in this.state.deviceTypes ? this.state.deviceTypes[this.state.smartDevice.devicetype] : this.state.smartDevice.devicetype}</Table.Cell></Table.Row>
            {this.state.smartDevice.devicetype=='ESME' && <Table.Row><Table.Cell><b>ESME Variant</b></Table.Cell><Table.Cell>{this.state.smartDevice.esmevariant in this.state.esmeVariants ? this.state.esmeVariants[this.state.smartDevice.esmevariant] : this.state.smartDevice.esmeVariant}</Table.Cell></Table.Row>}
            {this.state.smartDevice.devicetype=='CHF' && <Table.Row><Table.Cell><b>HAN Variant</b></Table.Cell><Table.Cell>{this.state.smartDevice.hanvariant}</Table.Cell></Table.Row>}
            <Table.Row><Table.Cell><b>Manufacturer / Model</b></Table.Cell><Table.Cell>{this.state.smartDevice.manufacturer in this.state.manufacturers ? this.state.manufacturers[this.state.smartDevice.manufacturer] : this.state.smartDevice.manufacturer} / {this.state.smartDevice.model}</Table.Cell></Table.Row>
            <Table.Row><Table.Cell><b>Firmware Version / Status</b></Table.Cell><Table.Cell>{this.state.smartDevice.firmwareversion} / {this.state.smartDevice.firmwareversionstatus}</Table.Cell></Table.Row>
            <Table.Row><Table.Cell><b>SMETS/CHTS / GBCS Version</b></Table.Cell><Table.Cell>{this.state.smartDevice.smetschtsversion} / {this.state.smartDevice.devicegbcsversion}</Table.Cell></Table.Row>
            <Table.Row><Table.Cell><b>DCC Status</b></Table.Cell><Table.Cell>{this.state.smartDevice.devicestatus} {this.state.smartDevice.datecommissioned && ' (' +this.state.smartDevice.datecommissioned+')'}</Table.Cell></Table.Row>

          </Table>
          </div>
      </Tab.Pane> });    

      if (this.state.hanDevices.length>0)
      {
        headerPanes.push({ menuItem: {key: 'HAN', content: 'HAN', icon: 'home'}, render: () => 
        <Tab.Pane>
          <div className="deviceheader">
            <List>
              <List.Item>
              <List.Icon name='home' />
              <List.Content>
                <List.Header>Home Area Network</List.Header>
              <List.List>
                {this.state.hanDevices.map(device=>{return this.renderHANDevice(device)})}
              </List.List>
              </List.Content>
              </List.Item>
              {/* {this.renderHANDevice(this.state.chfDevice)} */}
            </List>
            </div>
        </Tab.Pane> });    

      }

      if (this.state.smartDevice.deviceconfiguration)
        headerPanes.push({ menuItem: {key: 'Device Configuration', content: 'Device Configuration', icon: 'wrench'}, render: () => 
          <Tab.Pane>
            <div className="deviceheader">
            <Table className="formtable">
              {this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.billingcalendar && this.state.smartDevice.deviceconfiguration.billingcalendar.BillingCalendar && <Table.Row><Table.Cell><b>Billing Calendar</b></Table.Cell><Table.Cell>{this.formatBiillingCalendar(this.state.smartDevice.deviceconfiguration.billingcalendar.BillingCalendar)}</Table.Cell>
              <Table.Cell><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.billingcalendar.lastupdated))}</i></Table.Cell></Table.Row>}
              {this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.schedule && this.state.smartDevice.deviceconfiguration.schedule.DSPSchedules && <Table.Row>
                <Table.Cell><b>Schedule</b></Table.Cell>
                <Table.Cell>
                  <List>
              {objectOrArraytoArray(this.state.smartDevice.deviceconfiguration.schedule.DSPSchedules).map(schedule=>{return <List.Item><List.Content><List.Header>{schedule.DSPScheduleID} - {this.srvDescription(schedule.DSPScheduleDetails.DSPScheduledServiceReferenceVariant)}</List.Header></List.Content>{this.formatSchedule(schedule.DSPScheduleDetails)}</List.Item>})}
                  </List>
                  </Table.Cell>
                  <Table.Cell><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.schedule.lastupdated))}</i></Table.Cell>
                </Table.Row>}

              {this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.paymentmode && this.state.smartDevice.deviceconfiguration.paymentmode.PaymentMode && <Table.Row>
                <Table.Cell><b>Payment Mode</b></Table.Cell><Table.Cell>{this.state.smartDevice.deviceconfiguration.paymentmode.PaymentMode}</Table.Cell>
                <Table.Cell><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.paymentmode.lastupdated))}</i></Table.Cell></Table.Row>}
              {this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.instantaneouspowerthresholds && 
              <Table.Row><Table.Cell><b>Instaneous Power Thresholds</b></Table.Cell>
              <Table.Cell><List>
                <List.Item>Low / Medium Threshold: {this.state.smartDevice.deviceconfiguration.instantaneouspowerthresholds.LowMediumPowerThreshold}W</List.Item>
                <List.Item>Medium / High Threshold: {this.state.smartDevice.deviceconfiguration.instantaneouspowerthresholds.MediumHighPowerThreshold}W</List.Item>
                </List></Table.Cell>
                <Table.Cell><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.instantaneouspowerthresholds.lastupdated))}</i></Table.Cell>
                </Table.Row>}
                {this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.loadlimitsettings && 
              <Table.Row><Table.Cell><b>Load Limit Settings</b></Table.Cell>
              <Table.Cell><List>
                <List.Item>Period: {this.state.smartDevice.deviceconfiguration.loadlimitsettings.LoadLimitPeriod}s</List.Item>
                <List.Item>Power Threshold: {this.state.smartDevice.deviceconfiguration.loadlimitsettings.LoadLimitPowerThreshold}W</List.Item>
                <List.Item>Restoration Period: {this.state.smartDevice.deviceconfiguration.loadlimitsettings.LoadLimitRestorationPeriod}s</List.Item>
                <List.Item>Supply State: {this.state.smartDevice.deviceconfiguration.loadlimitsettings.LoadLimitSupplyState}</List.Item>
                </List></Table.Cell>
                <Table.Cell><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.loadlimitsettings.lastupdated))}</i></Table.Cell>
                </Table.Row>}                
              
            </Table>
            </div>
          </Tab.Pane> });    

      if (this.state.smartDevice.healthcheckresults)
      headerPanes.push({ menuItem: {key: 'Health Check', content: 'Health Check', icon: 'first aid'}, render: () => 
        <Tab.Pane>
          <div className="deviceheader">
          <i>Last health check run at {formatDateTime(new Date(this.state.smartDevice.healthcheckresults.healthcheckdate))}</i>
          <Table className="formtable">
          {this.state.smartDevice.healthcheckresults.connectivity && <Table.Row><Table.Cell><b>Connectivity</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.connectivity.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.connectivity.status)}/>{this.state.smartDevice.healthcheckresults.connectivity.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.certificates && <Table.Row><Table.Cell><b>Certificates</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.certificates.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.certificates.status)}/>{this.state.smartDevice.healthcheckresults.certificates.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.schedule && <Table.Row><Table.Cell><b>Schedule</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.schedule.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.schedule.status)}/>{this.state.smartDevice.healthcheckresults.schedule.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.tariff && <Table.Row><Table.Cell><b>Tariff</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.tariff.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.tariff.status)}/>{this.state.smartDevice.healthcheckresults.tariff.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.firmware && <Table.Row><Table.Cell><b>Firmware</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.firmware.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.firmware.status)}/>{this.state.smartDevice.healthcheckresults.firmware.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.paymentmode && <Table.Row><Table.Cell><b>Payment Mode</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.paymentmode.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.paymentmode.status)}/>{this.state.smartDevice.healthcheckresults.paymentmode.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.powerthresholds && <Table.Row><Table.Cell><b>Power Thresholds</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.powerthresholds.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.powerthresholds.status)}/>{this.state.smartDevice.healthcheckresults.powerthresholds.details}</Table.Cell></Table.Row>}
            {this.state.smartDevice.healthcheckresults.securityalerts && <Table.Row><Table.Cell><b>Security Alerts</b></Table.Cell><Table.Cell><Icon color={this.healthCheckColour(this.state.smartDevice.healthcheckresults.securityalerts.status)} name={this.healthCheckIcon(this.state.smartDevice.healthcheckresults.securityalerts.status)}/>{this.state.smartDevice.healthcheckresults.securityalerts.details}</Table.Cell></Table.Row>}

          </Table>
          </div>
        </Tab.Pane> });    


      if (tariff)
        headerPanes.push({ menuItem: {key: 'Tariff', content: 'Tariff', icon: 'pound'}, render: () => 
        <Tab.Pane>
          <div className="deviceheader">
          <b>Primary Tariff</b>
            <Table compact>
            <Table.Header>
              <Table.HeaderCell>Line</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
            </Table.Header>
            <Table.Row>
              <Table.Cell>Standing Charge</Table.Cell>
              <Table.Cell>{tariff.StandingCharge==="0" ? 0 : (Number(tariff.StandingCharge)*(10**(Number(tariff.StandingChargeScale)+2))).toFixed(3) }p/day</Table.Cell>
            </Table.Row>
            {tariff.TariffTOUPriceMatrix && this.objectToList(tariff.TariffTOUPriceMatrix.TariffTOUPrice).filter(line=>{return line['#text']!=='0'}).map((line, i)=>{
              return <Table.Row>
              <Table.Cell>Unit Rate {i+1}</Table.Cell>
              <Table.Cell>{(Number(line['#text'])*(10**(Number(tariff.PriceScale)+2))).toFixed(3) }p/kWh</Table.Cell>
            </Table.Row>

            })}
          </Table>
          {tariff.TariffSwitchingTable && <Popup on='click' trigger={<a>View switching times</a>}>
              <Popup.Content>
                <TariffSwitchingTimes tariff={tariff}/>
              </Popup.Content>
            </Popup>}
            <div><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.primarytariff.lastupdated))}</i></div>
            </div>
        </Tab.Pane> });    

      if (this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.krpcertificates && this.state.smartDevice.deviceconfiguration.krpcertificates.RemotePartyDetails)
        headerPanes.push({ menuItem: {key: 'Certificates', content: 'Certificates', icon: 'certificate'}, render: () => 
        <Tab.Pane>
          <div className="deviceheader">
            <b>KRP Certificates</b>
            <Table definition celled>
              <Table.Header>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>Digital Signing</Table.HeaderCell>
                <Table.HeaderCell>Key Agreement</Table.HeaderCell>
                <Table.HeaderCell>Key Agreement Top Up</Table.HeaderCell>
              </Table.Header>
              <Table.Row>
                <Table.Cell>ACB</Table.Cell>
                <Table.Cell negative/>
                <Table.Cell>{this.krpCertificateSlot('ACB', 'KeyAgreement')}</Table.Cell>
                <Table.Cell negative/>
              </Table.Row>
              <Table.Row>
                <Table.Cell>tCOS</Table.Cell>
                <Table.Cell>{this.krpCertificateSlot('TransCoS', 'DigitalSigning')}</Table.Cell>
                <Table.Cell negative/>
                <Table.Cell negative/>
              </Table.Row>            
              <Table.Row>
              <Table.Cell>Supplier</Table.Cell>
                <Table.Cell>{this.krpCertificateSlot('Supplier', 'DigitalSigning')}</Table.Cell>
                <Table.Cell>{this.krpCertificateSlot('Supplier', 'KeyAgreement')}</Table.Cell>
                <Table.Cell>{this.krpCertificateSlot('Supplier', 'KeyAgreementTopUp')}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Network Operator</Table.Cell>
                <Table.Cell>{this.krpCertificateSlot('NetworkOperator', 'DigitalSigning')}</Table.Cell>
                <Table.Cell>{this.krpCertificateSlot('NetworkOperator', 'KeyAgreement')}</Table.Cell>
                <Table.Cell negative/>
              </Table.Row>

            </Table>
            <div><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.krpcertificates.lastupdated))}</i></div>
            </div>
        </Tab.Pane> });    

if (this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.eventandalertbehaviours && this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.ElectricitySupplierAlertEventSettings)
headerPanes.push({ menuItem: {key: 'Alert Configuration', content: 'Alert Configuration', icon: 'exclamation'}, render: () => 
<Tab.Pane>
  <div className="deviceheader">
    <List>
      {Object.keys(this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.ElectricitySupplierAlertEventSettings).map(category=>
        {return <List.Item>
          <List.Header>{category}</List.Header>
          <List.List>
            {Object.keys(this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.ElectricitySupplierAlertEventSettings[category]).map(subcategory=>
            {
              return <List.Item>
                <List.Header>{subcategory}</List.Header>
                <List.List>
                  {Object.keys(this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.ElectricitySupplierAlertEventSettings[category][subcategory]).map(alertcode=>
                  {
                    return <List.Item>
                      <List.Content>{alertcode} - {this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.ElectricitySupplierAlertEventSettings[category][subcategory][alertcode]}</List.Content>
                    </List.Item>
                  })}
                </List.List>
              </List.Item>
            })}
          </List.List>
        </List.Item>})}             
    </List>
    <div><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.lastupdated))}</i></div>
    </div>
</Tab.Pane> });    

if (this.state.smartDevice.deviceconfiguration && this.state.smartDevice.deviceconfiguration.eventandalertbehaviours && this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.GasSupplierAlertEventSettings)
headerPanes.push({ menuItem: {key: 'Alert Configuration', content: 'Alert Configuration', icon: 'exclamation'}, render: () => 
<Tab.Pane>
  <div className="deviceheader">
    <List>
      {Object.keys(this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.GasSupplierAlertEventSettings).map(alertcode=>
                  {
                    return <List.Item>
                      <List.Content>{alertcode} - {this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.GasSupplierAlertEventSettings[alertcode].WANAlert}</List.Content>
                    </List.Item>
                  })}
    </List>
    <div><i>Updated {formatDateTime(new Date(this.state.smartDevice.deviceconfiguration.eventandalertbehaviours.lastupdated))}</i></div>
    </div>
</Tab.Pane> });    


      detailPanes.push({ menuItem: {key: 'Events', content: 'Events', icon: 'table'}, render: () => 
          <Tab.Pane>
            <SmartEvents smartdeviceid={this.props.match.params.smartdeviceid} deviceid={this.state.deviceLoaded && this.state.smartDevice.deviceid } user={this.props.user} darkmode={this.props.darkmode}/>
        </Tab.Pane> });
      detailPanes.push({ menuItem: {key: 'Health Checks', content: 'Health Checks', icon: 'first aid'}, render: () => 
      <Tab.Pane>
        <SmartHealthchecks smartdeviceid={this.props.match.params.smartdeviceid} user={this.props.user} darkmode={this.props.darkmode}/>
    </Tab.Pane> });    

      detailPanes.push({ menuItem: {key: 'Orchestrations', content: 'Orchestrations', icon: 'cogs'}, render: () => 
      <Tab.Pane>
        <SmartDeviceOrchestrations smartdevice={this.state.smartDevice } user={this.props.user} darkmode={this.props.darkmode}/>
    </Tab.Pane> });
      detailPanes.push({ menuItem: {key: 'Device Log', content: 'Device Log', icon: 'list'}, render: () => 
      <Tab.Pane>
        <SmartDeviceLog smartdeviceid={this.props.match.params.smartdeviceid} user={this.props.user} darkmode={this.props.darkmode}/>
    </Tab.Pane> });    

    }

return <Container className="fullpage">
      {this.state.deviceLoaded && <div>
      <div className="deviceheadertab">
      <Header centered as='h3' className={this.state.darkmode ? "darkmode" : "seaglassblue"}><Icon name='disk'/>{this.state.smartDevice.deviceid}</Header>
      <Tab grid= {{paneWidth: 13, tabWidth: 3}} menu={{className: this.props.darkmode ? "seaglassblueinverted-darkmode viewtabmenu" : "seaglassblueinverted viewtabmenu", inverted: true, overflow: "auto", tabular: false, fluid: true}} panes={headerPanes} />
      </div>
      {this.state.updateFailed && <Message error header="Failed to save smart device" list={this.state.validationErrors}/>}
      {this.state.updateSuccess && <Message success header="Smart device successfully saved"/>}        

      <Divider/>
      <div className="devicedetailtab">
      <Tab menu={{secondary: true, pointing: true , className: this.props.darkmode ? "seaglassblue-darkmode" : "seaglassblue", inverted: this.props.darkmode,  }} panes={detailPanes} />
      </div>
      <Modal open={this.state.showUpdateDeviceConfig} style={modalStyle.modal}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="edit"/>Update Device Configuration</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Select label="Device Configuration" fluid required placeholder='Device Configuration' value={this.state.smartDevice.deviceconfigurationrules} options={Object.keys(this.state.deviceConfigurations).map(key=>{return {key: key, value: key, text: key}})} onChange={(event, data)=>{this.updateSmartDevice('deviceconfigurationrules', data.value)}}></Form.Select>
        <Divider/>
        <Button className='seaglassbutton' onClick={()=>this.saveSmartDevice()}>Save</Button>
        <Button className="seaglassbutton" onClick={()=>{this.setState({showUpdateDeviceConfig: false})}}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>   
        <Modal open={this.state.showUpdateAlertConfig}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="edit"/>Update Alert Configuration</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Select label="Alert Configuration" fluid required placeholder='Alert Configuration' value={this.state.smartDevice.alertconfigurationrules} options={Object.keys(this.state.alertConfigurations).map(key=>{return {key: key, value: key, text: key}})} onChange={(event, data)=>{this.updateSmartDevice('alertconfigurationrules', data.value)}}></Form.Select>
        <Divider/>
        <Button className='seaglassbutton' onClick={()=>this.saveSmartDevice()}>Save</Button>
        <Button className="seaglassbutton" onClick={()=>{this.setState({showUpdateAlertConfig: false})}}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>   


      </div>

     }
    </Container>
   }
}

